import { render, staticRenderFns } from "./DialogDurationScheduleEdit.vue?vue&type=template&id=bb8f0ebc"
import script from "./DialogDurationScheduleEdit.vue?vue&type=script&lang=js"
export * from "./DialogDurationScheduleEdit.vue?vue&type=script&lang=js"
import style0 from "./DialogDurationScheduleEdit.vue?vue&type=style&index=0&id=bb8f0ebc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports